import { SagaIterator } from "@redux-saga/types";
import { HttpResponseTypeEnum } from "enumerations/HttpResponseTypeEnum";
import { PrivacyPolicyAction } from "../../redux-container/privacy-policy/PrivacyPolicy";
import { call, put } from "redux-saga/effects";

export function* getPrivacyPolicySaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getPrivacyPolicy, action.pageType);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(PrivacyPolicyAction.getPrivacyPolicySuccess(response.data));
    } else {
      yield put(PrivacyPolicyAction.getPrivacyPolicyFailure(response.data));
    }
  } catch (error) {
    yield put(PrivacyPolicyAction.getPrivacyPolicyFailure(error));
  }
}
